export const policyDataSelector = (state) => {
    return state.policyData;
};